import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Tabs } from "antd";
import { Main } from "../../styled";
import { PageHeader } from "../../../components/page-headers/page-headers";

import { useTranslation } from "react-i18next";
import InfoFormLeft from "./infoFormLeft";

import { useSelector, useDispatch } from "react-redux";
import { GetGraphQlData } from "../actions/dataQueries";

import { setAllServices } from "../../../redux/services/actionCreator";
import InfoFormRight from "./infoFormRight";
import List from "./items/list";

import { useApplicationSettings } from "../../../utils/common";
import { CarStorage } from "../../car/overview/tabs/carStorage";

const { TabPane } = Tabs;

const graphqlVariables = {
  tokenGet: process.env.REACT_APP_TOKEN_GET,
  tokenMutation: process.env.REACT_APP_TOKEN_MUTATION,
  offset: 0,
  limit: 0,
  status: undefined,
  search: undefined,
};

const ActionDetail = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const params = useParams();
  const id = params.id;
  const actionId = id.toString().padStart(7, "0");
  graphqlVariables.id = id;

  const [loadData, setLoadData] = useState(false);
  const [canDisplay, setCanDisplay] = useState(false);
  const [canDisplayProductGrid] = useState(true);
  const [ayvensState, setAyvensState] = useState({
    isAyvensVehicle: false,
  });
  const [serviceItems, setServiceItems] = useState();
  const [carOwnerId, setCarOwnerId] = useState();
  const [carOwnerCode, setCarOwnerCode] = useState();
  const [carOwnerBonus, setCarOwnerBonus] = useState();
  const [statusChange, setStatusChange] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [serviceId, setServiceId] = useState();

  const serviceData = useSelector((state) => state?.services?.allServices[0]);
  const selectedCar = { storage: serviceData?.car?.storage };

  useEffect(() => {
    setLoadData(true);
  }, []);

  const graphQlData = GetGraphQlData(graphqlVariables, loadData);
  const servicesData = graphQlData[0]?.data?.getServiceActions?.records;
  useEffect(() => {
    if (!Array.isArray(servicesData) || servicesData.length === 0) {
      return;
    }
    const first = servicesData[0];

    setLoadData(false);
    setCanDisplay(true);
    setCarOwnerId(first?.carOwner?.id);
    setCarOwnerBonus(first?.carOwner?.bonus);
    dispatch(setAllServices(servicesData));
    setStatusChange(first?.status);
    setCarOwnerCode(first?.carOwner?.code || null);
    setServiceId(first?.id);
    setServiceItems(first?.items); // backend may return items; keep guarded
  }, [servicesData, dispatch]);

  const settings = useApplicationSettings("invoicing", loadData);
  useEffect(() => {
    if (settings) {
      setInvoiceData(settings);
    }
  }, [settings]);
  useEffect(() => {
    if (carOwnerCode === "ayvens") {
      // if (
      //   serviceData?.ayvens_contract_number &&
      //   serviceData?.ayvens_contract_number !== ""
      // ) {
      //   setCanDisplayProductGrid(true);
      // } else {
      //   setCanDisplayProductGrid(false);
      // }
      setAyvensState({
        isAyvensVehicle: true,
      });
    }
  }, [carOwnerCode]);

  return (
    canDisplay && (
      <>
        <PageHeader
          ghost
          title={t("serviceActions.detail.title") + " " + actionId}
        />
        <Main>
          <Row gutter={25}>
            <Col xs={24}>
              <Tabs>
                <TabPane
                  tab={t("serviceActions.detail.tabs.tab2Title")}
                  key="tab2"
                >
                  <InfoFormRight
                    t={t}
                    data={serviceData}
                    graphqlVariables={graphqlVariables}
                    setStatusChange={setStatusChange}
                    invoiceData={invoiceData}
                    additionalInfo={{
                      ayvensState: ayvensState,
                      carOwnerCode: carOwnerCode,
                      licencePlate: serviceData?.car?.licence_plate,
                      serviceId: serviceId,
                      serviceItems: serviceItems,
                    }}
                  />
                </TabPane>
                <TabPane
                  tab={t("serviceActions.detail.tabs.tab1Title")}
                  key="tab1"
                >
                  <InfoFormLeft t={t} data={serviceData} />
                </TabPane>
                <TabPane
                  tab={t("serviceActions.detail.tabs.tab3Title")}
                  key="tab3"
                >
                  <CarStorage t={t} carData={selectedCar} />
                </TabPane>
              </Tabs>
            </Col>
          </Row>
          {canDisplayProductGrid && (
            <Row gutter={25}>
              <Col xs={24}>
                <List
                  t={t}
                  data={serviceData}
                  inputData={serviceItems}
                  graphqlVariables={graphqlVariables}
                  carOwnerId={carOwnerId}
                  carOwnerBonus={carOwnerBonus}
                  serviceActionId={id}
                  statusChange={statusChange}
                  carOwnerCode={carOwnerCode}
                />
              </Col>
            </Row>
          )}
        </Main>
      </>
    )
  );
};

export default ActionDetail;
